var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-conent main-conent-maxheight"},[_c('div',{staticClass:"screen-frame"},[_c('iframe',{staticStyle:{"position":"relative","top":"0px","height":"100%"},attrs:{"src":_vm.src,"width":"100%"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }